import { Suspense, lazy } from 'react';
import { Navigate, useRoutes, useLocation, Outlet } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { useSelector } from 'react-redux';
import {useState, useEffect} from 'react'
import api from 'src/Api'
import Chatbot from 'src/pages/main/Chatbot';

// Layouts
import DashboardLayout from '../layouts/dashboard';
import LogoOnlyLayout from '../layouts/LogoOnlyLayout';

// Components
import LoadingScreen from '../components/LoadingScreen';
import VerifyAccount from 'src/pages/dashboard/accounts/VerifyAccount';
import HomeLayout from 'src/pages/main/HomeLayout';
import Footer from 'src/pages/main/Footer'
import Header from 'src/pages/main/Header'

import { element } from 'prop-types';

// ----------------------------------------------------------------------

function Auth({ children, ...rest }) {
  const auth = useSelector((state) => state.auth);
  if (auth.isAuthenticated) {
    return children;
  } else return <Navigate to="/" replace={true} />;
}

const Loadable = Component => props => {
	// eslint-disable-next-line react-hooks/rules-of-hooks
	const { pathname } = useLocation()

	return (
		<Suspense fallback={<LoadingScreen isDashboard={pathname.includes('/dashboard')} />}>
			<Component {...props} />
		</Suspense>
	)
}

function Home() {
  const auth = useSelector((state) => state.auth);
  
  if (auth.user.role === -1) return <HomeSuperAdmin />;
  if (auth.user.role === 0) return <HomeAdmin />;
  if (auth.user.role === 1) return <HomePro />;
  if (auth.user.role === 2) return <NotFound />;
  
  return <NotFound />; // Optional: return 404 by default if no role matches
}

// function Account() {
//   const auth = useSelector((state) => state.auth);
//   if (auth.user.role === 2) return <AccountExtra />;
//   else return <Home />;
// }

function Account() {
  const auth = useSelector((state) => state.auth);
   if (auth.user.role !== 2) return <Home />
   else return <NotFound />
}

export default function Router() {
  const auth = useSelector((state) => state.auth);
  const path = auth.user && auth.user.role === 1 ? '/dashboard/home' : '/dashboard/home';
  const location = useLocation(); // Appel correct de useLocation

  const [userExists, setUserExists] = useState(null); // Assume user exists by default

  useEffect(() => {
    const checkStripeCustomer = async (id) => {
      try {
        const response = await api.get(`stripe/customer?id=${id}`);
        const data = await response.data;

        if (data.exists === false) {
          setUserExists(false); // Redirect to CompleteStripe if the user doesn't exist in Stripe
        }else{
          setUserExists(true)
        }
      } catch (error) {
        console.error("Error checking Stripe customer:", error);
      }
    };
    if(auth.user){
    const userId = auth.user.id // Replace with actual logic to get the logged-in user's email
    checkStripeCustomer(userId);
    }
  }, []);

  //console.log(userExists)

  return  useRoutes([
          {
            path: '/notActive',
            element: <NotActive />,
          },
          {
            path: '/dashboard',
            element: (
              <Auth>
                <VerifyAccount>
                  <DashboardLayout />
                </VerifyAccount>
              </Auth>
            ),
            children: [
              { element: <Navigate to={path} replace />, index: true },
              { path: 'home', element: <Home /> },
              { path: 'clients', element: <Clients /> },
              { path: 'clients/:id', element: <ClientsInfo /> },
              { path: 'candidats/:id', element: <CondidatsInfo /> },
              { path: 'admins', element: <Admins /> },
              { path: 'cancel_requests', element: <CancelRequests /> },
              { path: 'cancel_requests_pro', element: <CancelRequestsPro /> },
              { path: 'candidats', element: <Candidats /> },
              { path: 'applications', element: <ApplicationsPro /> },
              { path: 'application_details/:id', element: <ApplicationDetails /> },
              { path: 'all_applications', element: <ApplicationsAdmin /> },
              { path: 'my_applications', element: <ApplicationsExtra /> },
              { path: 'Settings', element: <Settings /> },
              // { path: 'profile', element: <Profile /> },
              { path: 'profile_pro', element: <ProfilePro /> },
              { path: 'account', element: <Account /> },
              { path: 'all_missions', element: userExists === null ? <LoadingScreen /> : userExists ? <MissionsPro /> : <Stripe /> },
              { path: 'all_missions/add', element: userExists === null ? <LoadingScreen /> : userExists ? <AddMission /> : <Stripe /> },
              { path: 'all_missions/edit/:id', element: userExists === null ? <LoadingScreen /> : userExists ? <EditMission /> : <Stripe /> },
              { path: 'all_missions/show/:id', element: userExists === null ? <LoadingScreen /> : userExists ? <ShowMission /> : <Stripe /> },
              { path: 'admin_missions', element: <MissionsAdmin /> },
              { path: 'admin_missions_details', element: <MissionsDetailsAdmin /> },
              { path: 'all_invoices', element: <InvoicesPro /> },
              { path: 'admin_inovices', element: <InvoicesAdmin /> },
              // { path: 'missions', element: <MissionsExtra /> },
              // { path: 'invoices', element: <InvoicesExtra /> },
              { path: 'appointments', element: <Appointments /> },
              
              { path: 'job_offers', element: <JobOffers /> },
              { path: 'favorite_candidates', element: <Favorites />},
              { path: 'job_offers_pro', element: <JobOffersPro /> },
              { path: 'add_job_offer', element: <AddJobOffer /> },
              { path: 'add_job_offer_pro', element: <AddJobOfferPro /> },
              { path: 'edit_job_offers_pro', element: <EditJobOfferPro /> },
              { path: 'edit_job_offers', element: <EditJobOffer /> },
              { path: 'job_offer_details/:id', element: <JobOfferDetails /> },

              { path: 'messages', element: <Messages />},



              {path: 'articles', element: <Articles />},
              { path: 'articles/add', element: <AddArticle />},
              {path: 'articles/edit/:id', element: <EditArticle />}
            ],
          },
          {
            path: '/',
            element: (
              // <HomeLayout>
              
                <Suspense fallback={<LoadingScreen />}>
                  <Header/>
                  {/* <Chatbot /> */}
                  <main style={{ marginTop: '75px' }}>
    <Outlet />
  </main>
                  <Footer />
                </Suspense>
                
              // </HomeLayout>
            ),
            children: [
              { path: '/', element: <Main /> },
              { path: 'login', element: <Login /> },
              { path: 'register', element: <Register /> },
              { path: 'verify', element: <VerifyEmail /> },
              { path: 'reset_password', element: <ResetPassword /> },
              { path: 'register/pro', element: <RegisterOne /> },
             // { path: 'register/ext', element: <RegisterTwo /> },
              { path: 'contact', element: <ContactUs /> },
              { path: 'jobs', element: <Jobs /> },
              { path: 'filters', element: <FiltersBar />},
              { path: 'job_details/:id', element: <JobDetails /> },
              { path: 'job_apply/:id', element: <JobApply />},
              { path: 'services', element : <Services />},
              { path: 'faq', element: <Faq />},
              { path: 'mentions-legales', element: <MentionsLegales />}
            ],
          },
          {
            path: '*',
            element: (
              // <HomeLayout>
              
                <Suspense fallback={<LoadingScreen />}>
                  <Header/>
                  {/* <Chatbot /> */}
                  <main style={{ marginTop: '75px' }}>
    <Outlet />
  </main>
                  <Footer />
                </Suspense>
                
              // </HomeLayout>
            ),
            children: [
              { path: '404', element: <NotFound /> },
              { path: '*', element: <Navigate to="/404" replace /> },
            ],
          },
          { path: '*', element: <Navigate to="/404" replace /> },
        ])}
    //   </motion.div>
    // </AnimatePresence>
  


// Dashboard

const ContactUs = Loadable(lazy(() => import('../pages/main/ContactUs')));
const Jobs = Loadable(lazy(() => import('../pages/main/Jobs')));
const JobDetails = Loadable(lazy(() => import('../pages/main/JobDetails')));


const Services = Loadable(lazy(() => import('../pages/main/Services')))
const Login = Loadable(lazy(() => import('../pages/main/accounts/Login')));

const HomeSuperAdmin = Loadable(lazy(() => import('../pages/dashboard/home/HomeSuperAdmin')));
const HomeAdmin = Loadable(lazy(() => import('../pages/dashboard/home/HomeAdmin')));
const HomePro = Loadable(lazy(() => import('../pages/dashboard/home/HomePro')));
const HomeExtra = Loadable(lazy(() => import('../pages/dashboard/home/HomeExtra')));
const DownloadApp = Loadable(lazy(() => import('../components/register/CandidatePopup')))
const Main = Loadable(lazy(() => import('../pages/main/Main')));

const Register = Loadable(lazy(() => import('../pages/main/accounts/Register')));
const RegisterOne = Loadable(lazy(() => import('../pages/main/accounts/pro/Register')));
const RegisterTwo = Loadable(lazy(() => import('../pages/main/accounts/extra/Register')));

const VerifyEmail = Loadable(lazy(() => import('../pages/main/accounts/VerifyEmail')));
const ResetPassword = Loadable(lazy(() => import('../pages/main/accounts/ResetPassword')));
const NotFound = Loadable(lazy(() => import('../pages/Page404')));
const NotActive = Loadable(lazy(() => import('../pages/NotActive')));

const Admins = Loadable(lazy(() => import('../pages/dashboard/admin/admins/Admins')));
const Clients = Loadable(lazy(() => import('../pages/dashboard/admin/clients/Clients')));
const ClientsInfo = Loadable(lazy(() => import('../pages/dashboard/admin/clients/ClientInfo')));
const CondidatsInfo = Loadable(lazy(() => import('../pages/dashboard/admin/condidats/CondidatsInfo')));
const Candidats = Loadable(lazy(() => import('../pages/dashboard/admin/condidats/Condidats')));
const CancelRequests = Loadable(lazy(() => import('../pages/dashboard/admin/cancel_requests/CancelRequests')));
const CancelRequestsPro = Loadable(lazy(() => import('../pages/dashboard/pro/cancel_requests/CancelRequests')));
const ApplicationsPro = Loadable(lazy(() => import('../pages/dashboard/pro/applications/Applications')));
const ApplicationDetails = Loadable(lazy(() => import('../pages/dashboard/pro/applications/ApplicationDetails')));
const ApplicationsAdmin = Loadable(lazy(() => import('../pages/dashboard/admin/applications/Applications')));

const Appointments = Loadable(lazy(() => import('../pages/dashboard/admin/appointments/Appointments')));
const ApplicationsExtra = Loadable(lazy(() => import('../pages/dashboard/extra/applications/Applications')));
const Settings = Loadable(lazy(() => import('../pages/dashboard/settings/Settings')));

const AccountExtra = Loadable(lazy(() => import('../pages/dashboard/accounts/AccountExtra')));
const Profile = Loadable(lazy(() => import('../pages/dashboard/profiles/Profile')));
const ProfilePro = Loadable(lazy(() => import('../pages/dashboard/profiles/ProfilePro')));
const MissionsPro = Loadable(lazy(() => import('../pages/dashboard/pro/missions/Missions')));
const AddMission = Loadable(lazy(() => import('../pages/dashboard/pro/missions/AddMission')));
const EditMission = Loadable(lazy(() => import('../pages/dashboard/pro/missions/EditMission')));
const ShowMission = Loadable(lazy(() => import('../pages/dashboard/pro/missions/ShowMission')) )
const Stripe = Loadable(lazy(() => import('../pages/dashboard/pro/stripe/stripe')));
const InvoicesPro = Loadable(lazy(() => import('../pages/dashboard/pro/invoices/Invoices')));
const InvoicesAdmin = Loadable(lazy(() => import('../pages/dashboard/admin/invoices/Invoices')));
const InvoicesExtra = Loadable(lazy(() => import('../pages/dashboard/extra/invoices/Invoices')));
const MissionsExtra = Loadable(lazy(() => import('../pages/dashboard/extra/missions/Missions')));
const MissionsAdmin = Loadable(lazy(() => import('../pages/dashboard/admin/missions/Missions')));
const MissionsDetailsAdmin = Loadable(lazy(() => import('../pages/dashboard/admin/missions/MissionDetails')));



const JobOffers = Loadable(lazy(() => import('../pages/dashboard/admin/job_offers/JobOffers')));
const JobOffersPro = Loadable(lazy(() => import('../pages/dashboard/pro/job_offers/JobOffersPro')));
const AddJobOffer = Loadable(lazy(() => import('../pages/dashboard/admin/job_offers/AddJobOffer')));
const EditJobOffer = Loadable(lazy(() => import('../pages/dashboard/admin/job_offers/EditJobOffer')));
const AddJobOfferPro = Loadable(lazy(() => import('../pages/dashboard/pro/job_offers/AddJobOffer')));
const EditJobOfferPro = Loadable(lazy(() => import('../pages/dashboard/pro/job_offers/EditJobOffer')));
const JobOfferDetails = Loadable(lazy(() => import('../pages/dashboard/admin/job_offers/JobOfferDetails')));
const JobApply = Loadable(lazy(() => import('../pages/main/JobApply')));
const Faq = Loadable(lazy(() => import('../pages/main/FAQ')));
const MentionsLegales = Loadable(lazy(() => import('../pages/main/MentionsLegales')));


const Messages = Loadable(lazy(() => import('../pages/dashboard/admin/messages/Messages')))



const Favorites = Loadable(lazy(() => import('../pages/dashboard/pro/favorites/Favorites')))

const FiltersBar = Loadable(lazy(() => import ('../components/jobs/FiltersBar')))



const Articles = Loadable(lazy(() => import('../pages/dashboard/admin/blog/Articles')))
const AddArticle = Loadable(lazy(() => import('../pages/dashboard/admin/blog/AddArticle')))
const EditArticle = Loadable(lazy(() => import('../pages/dashboard/admin/blog/EditArticle')))
